import React, { useState, useEffect, useRef } from 'react';

const THEMES = [
  { id: 'light', label: 'White', icon: '☀️', swatch: '#f5f7fb' },
  { id: 'dark', label: 'Black', icon: '🌑', swatch: '#0a0f1e' },
  { id: 'multicolor', label: 'Multicolor', icon: '🎨', swatch: '#f472b6' },
];

export function applyStoredTheme() {
  const theme = localStorage.getItem('cu_theme') || 'light';
  document.documentElement.setAttribute('data-theme', theme);
}

export default function ThemeSwitcher() {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('cu_theme') || 'light');
  const panelRef = useRef(null);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('cu_theme', theme);
  }, [theme]);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  return (
    <div style={{ position: 'fixed', bottom: 148, right: 24, zIndex: 9998 }}>
      {open && (
        <div ref={panelRef} style={{
          position: 'absolute', bottom: 56, right: 0, width: 200,
          background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12,
          padding: 12, boxShadow: '0 8px 30px rgba(0,0,0,0.5)',
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10, color: 'var(--text-primary)' }}>Theme</div>
          {THEMES.map(t => (
            <button key={t.id} onClick={() => { setTheme(t.id); setOpen(false); }} style={{
              display: 'flex', alignItems: 'center', gap: 10, width: '100%',
              padding: '8px 10px', borderRadius: 8, marginBottom: 4, cursor: 'pointer',
              border: theme === t.id ? '1px solid var(--accent)' : '1px solid var(--border)',
              background: theme === t.id ? 'var(--accent-glow)' : 'transparent',
              color: 'var(--text-primary)', fontSize: 13,
            }}>
              <span style={{ width: 14, height: 14, borderRadius: '50%', background: t.swatch, border: '1px solid var(--border)' }} />
              <span>{t.icon} {t.label}</span>
            </button>
          ))}
        </div>
      )}
      <button onClick={() => setOpen(o => !o)} title="Theme" style={{
        width: 48, height: 48, borderRadius: '50%', border: '1px solid var(--border)',
        background: 'var(--bg-card)', color: 'var(--text-primary)',
        fontSize: 20, cursor: 'pointer', boxShadow: '0 4px 14px rgba(0,0,0,0.4)',
      }}>🎨</button>
    </div>
  );
}
